import { queryOptions, useQuery } from "@tanstack/react-query"
import { GET } from "@/api/client"

export function profitCalendarOptions() {
	return queryOptions({
		queryKey: ["trading", "profit-calendar"],
		queryFn: () => GET("/api/v1/trading/charts/profit-calendar"),
	})
}

export function useProfitCalendar() {
	return useQuery(profitCalendarOptions())
}
